import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import VueTheMask from "vue-the-mask";
import money from "v-money";
import UUID from "vue-uuid";
import Moment from "moment";
import { extendMoment } from "moment-range";
import VRM from "vue-role-manager";
import { roleMixin } from "@/mixins";

import "@/assets/scss/app.scss";
import "./plugins/axios";

const moment = extendMoment(Moment);
moment.locale("pt-BR");

Vue.use(Buefy);
Vue.use(VueTheMask);
Vue.use(money, { precision: 4 });
Vue.use(UUID);
Vue.use(require("vue-moment"), { moment });
Vue.use(VRM, { router: router, debug: false });
Vue.mixin(roleMixin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
